import { findAllByTestId } from '@testing-library/react';
import firebase from 'firebase/app';
import 'firebase/functions';
import selectRandom from './selectRandom'

function hasDuplicates(array) {
	return (new Set(array)).size !== array.length;
}

const avaliblePads = [1,2,3,4,5,6,7,8,9,10,12,13]

async function getRandomCzechWords() {
	const timer = new Date()
	const db = firebase.firestore();
	const getPersonalForm = firebase.functions().httpsCallable('getPersonalForm');

	let isSuitable = false

	// Fetch random dictionary until we find suitable (not empty)
	while (!isSuitable) {
		// Fetch all dictionary docs
		const dictionaryDocs = await db.collectionGroup('dictionaries').get()

		// Select random dictionary doc
		// const randomDictionaryDoc = selectRandom(dictionaryDocs.docs)
		const randomDictionaryDoc = db.doc('/users/318951201/dictionaries/voXTt6awrmyrZIq851ds')

		// Fetch words from this dictionary
		var randomDictionaryWords = await randomDictionaryDoc.collection('words').get()

		if (!randomDictionaryWords.empty) {

			console.log(randomDictionaryWords.docs)
			// Filter all nouns (we don't need verbs or anything else)
			var nouns = randomDictionaryWords.docs.filter(word => {
				return !!word.data().morfTags && !!word.data().morfTags.includes("podstatné jméno")
			})

		}

		isSuitable = !randomDictionaryWords.empty && nouns && nouns.length > 0
	}

	console.log('words fetched', Date.now() - timer)
	console.log(randomDictionaryWords.docs)


	// Select N random nouns
	const randomWords = Array(10)
		.fill(null)
		.map(() => {
			return selectRandom(nouns).data()
		})
	
	// Get personal forms for all words
	let wordsWithPads = await Promise.all(randomWords.map(async word => {
		// let pads;
		// try {
		//     pads = await getPersonalForm(word.cz)
		// } catch (err) {
		//     return null;
		// }
		// if (!pads || !pads.data) return null;
		// pads = pads.data;

		const pads = word.pads;

		if (!pads) return;

		// Get 4 random unique forms
		let variants;
		let correctFormID;
		let correctForm;
		for (let i = 0; i < 20; i++) {
			variants = Array(4).fill(null).map(el => selectRandom(pads))
			correctFormID = selectRandom(avaliblePads)
			correctForm = pads[correctFormID]
			variants[~~(Math.random() * 4)] = correctForm
			if (!hasDuplicates(variants)) {
				break;
			}
		}

		if (hasDuplicates(variants)) {
			// variants = [...new Set(variants)]
			return;
		}
		
		return { ...word.trans, pads, variants, correctFormID, correctForm }
	}))

	wordsWithPads = wordsWithPads
		.filter(word => !!word) // Filter failed fetch
		.map((word, id) => ({ ...word, id })); // Give id for every element

	console.log('grcw time', Date.now() - timer)

	return wordsWithPads;
}

export default getRandomCzechWords;